import React from "react";
//import '../../../AdminStyle';
export const Footer = () => {
  const date = new Date();
  const year = date.getFullYear();
  return (
    <footer className="sticky-footer bg-white">
      <div className="container my-auto">
        <div className="copyright text-center my-auto">
          <span>
            Copyright @ {year} <b className="text-black">Rater.</b> Powered By{" "}
            <a
              href="https://nichetechsolutions.com/"
              target="_blank"
              className="text-decoration-none text-black"
            >
              <b>Nichetech</b>
            </a>{" "}
            All rights reserved.{" "}
          </span>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
